export var EntityTypes;
(function (EntityTypes) {
    EntityTypes["ModuleCoverImg"] = "MODULE_COVER_IMG";
    EntityTypes["MentorshipCoverImg"] = "MENTORSHIP_COVER_IMG";
    EntityTypes["PageBackgroundImg"] = "PAGE_BACKGROUND_IMG";
    EntityTypes["PageMedia"] = "PAGE_MEDIA";
    EntityTypes["PageAttachment"] = "PAGE_ATTACHMENT";
})(EntityTypes || (EntityTypes = {}));
